import { gtmSendEvent } from "@wojo/analytics";
import { useI18n } from "@wojo/localization";
import { Markdown, Modal, ModalBody, Text } from "@wojo/ui";
import React, { useState } from "react";
import { FiInfo } from "react-icons/fi";
import { TourExtensionContent } from "../../../../generated/graphql";
import styles from "./TripBuilderDeparturesStep.module.scss";
import { useTourPageContext } from "../../../_client/context";

export type DepartureListPriceModalProps = {
    content?: Partial<TourExtensionContent> | null;
    formattedPrice?: string;
};

export const DepartureListPriceModal: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { tripBuilderPriceHelpText } = useTourPageContext();
    const { productPage } = useI18n("productPage");

    const heading = productPage.tripBuilder.departures.priceModal.title.l();
    const title = productPage.tripBuilder.departures.modalTriggerLabel.l({
        subject: productPage.tripBuilder.departures.priceModal.label.l(),
    });
    const description =
        tripBuilderPriceHelpText ||
        productPage.tripBuilder.departures.priceModal.description.l();
    return (
        <>
            <button
                className={styles["info-button"]}
                type="button"
                onClick={() => {
                    gtmSendEvent({
                        event: "track",
                        ga4Tracking: {
                            ga4_object: "TRIP_BUILDER",
                            ga4_action: "MODAL_OPENED",
                            modalId: "Price Info",
                        },
                    });
                    setIsOpen(true);
                }}
            >
                <FiInfo size={16} title={title} aria-label={title} />
            </button>
            <Modal
                onCloseRequested={() => {
                    gtmSendEvent({
                        event: "track",
                        ga4Tracking: {
                            ga4_object: "TRIP_BUILDER",
                            ga4_action: "MODAL_CLOSED",
                            modalId: "Price Info",
                        },
                    });
                    setIsOpen(false);
                }}
                isOpen={isOpen}
                accessibleTitle={title}
            >
                <ModalBody>
                    {!!heading && (
                        <Text.Heading
                            order="4"
                            tag="h2"
                            style={{ marginBottom: "var(--g-spacing-sm)" }}
                        >
                            {heading}
                        </Text.Heading>
                    )}
                    {!!description && <Markdown markdown={description} />}
                </ModalBody>
            </Modal>
        </>
    );
};
